import Vue from 'vue'
import axios from 'axios'
import {get, post, upload} from './plugins/http_utils'
import './assets/uniui.css'
import './assets/iconfont.css'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import fun from './plugins/fun.js'
Vue.prototype.fun = fun
import VCharts from 'v-charts'
Vue.use(VCharts)
Vue.prototype.api_url = 'https://api.pos.com.ve/';
//Vue.prototype.api_url = 'http://192.168.100.16:8876/';
Vue.prototype.axios = axios
Vue.prototype.get = get
Vue.prototype.post = post
Vue.prototype.upload = upload
Vue.config.productionTip = false

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/sw.js').catch(function () {})
  })
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js